export const INVALID_EMAIL_TITLE = "You can't join with this email";
